<template>
  <div class="transcription-wrapper" :class="[editing ? 'transcription-wrapper-editing' : 'transcription-wrapper-static']">
    <TranscriptionHeader v-model:editing="editing" />
    <TranscriptionList :editing="editing" />
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import TranscriptionHeader from './TranscriptionHeader.vue';
import TranscriptionList from './TranscriptionList.vue';

const editing = ref(false);
</script>
<style scoped>
.transcription-wrapper {
  @apply relative flex flex-col p-3 sm:p-4 gap-4 sm:border sm:rounded-10 bg-white dark:bg-zinc-900;
}

.transcription-wrapper-editing {
  @apply sm:border-blue-500/30 sm:ring sm:ring-blue-500/30;
}

.transcription-wrapper-static {
  @apply sm:border-slate-300 sm:dark:border-zinc-700;
}
</style>
